var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"RecommendsTable"},[_c('v-data-table',{staticClass:"RecommendsTable_Table",attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":50,"loading":_vm.loading,"dark":"","dense":"","disable-sort":""},scopedSlots:_vm._u([{key:"item.isMatched",fn:function(ref){
var item = ref.item;
return [(item.isMatched)?_c('v-icon',[_vm._v("mdi-history")]):_vm._e()]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }